angular.module('harriApp')
    .controller('TalentScoutRedirectionContainer', ['$scope', '$state', '$stateParams', function ($scope, $state, $stateParams) {
        const self = this;
        const brandId = $stateParams.brand_id;
        const codeId = $stateParams.code_id;

        $scope.redirect = () => {
            CoreReaderAPI.getTalentScoutRedirectionURL(brandId, codeId).then((res) => {
                window.location = res.redirect_url;
            }).catch((err) => {
                console.error(err)
                $state.go("404");
            })
        }

        const init = () => {
            if (brandId === '1503033') {
                $scope.showPage = true
            }
        }

        init();
    }]);